import React from "react"
import { Col, Row } from "antd";
import { FormSelect } from "../../../../components/form/FormSelect.component";


const FormRegisInfomantion = (
    {
        masterData
    }: {
        masterData: any
    }) => {

    return (
        <>
            <Row gutter={[24, 0]} className="items-end">
                <Col span={12}>
                    <FormSelect
                        options={masterData?.dayOptions}
                        label='第1希望日時'
                        required
                        name='preferred01Date'
                        labelClassName='content-step-form label-step-form'
                    />
                </Col>
                <Col span={12}>
                    <FormSelect
                        options={masterData?.timeOptions}
                        required
                        name='preferred01Time'
                        labelClassName='content-step-form label-step-form'
                    />
                </Col>
            </Row>
            <Row gutter={[24, 0]} className="items-end">
                <Col span={12}>
                    <FormSelect
                        label='第2希望日時'
                        options={masterData?.dayOptions}
                        required
                        name='preferred02Date'
                        labelClassName='content-step-form label-step-form'
                    />
                </Col>
                <Col span={12}>
                    <FormSelect
                        options={masterData?.timeOptions}
                        required
                        name='preferred02Time'
                        labelClassName='content-step-form label-step-form'
                    />
                </Col>
            </Row>
            <Row gutter={[24, 0]} className="items-end">
                <Col span={12}>
                    <FormSelect
                        label='第3希望日時'
                        options={masterData?.dayOptions}
                        required
                        name='preferred03Date'
                        labelClassName='content-step-form label-step-form'
                    />
                </Col>
                <Col span={12}>
                    <FormSelect
                        options={masterData?.timeOptions}
                        required
                        name='preferred03Time'
                        labelClassName='content-step-form label-step-form'
                    />
                </Col>
            </Row>
            <Row gutter={[24, 0]}>
                <Col span={24}>
                    所要時間は5分程度です。
                </Col>
            </Row>
        </>
    )
}
export default FormRegisInfomantion